// removed by extract-text-webpack-plugin
module.exports = {"imageOuterWrapper":"src-background----background-module---imageOuterWrapper---3CDOZ","imageWrapper":"src-background----background-module---imageWrapper---ZpAye"};


//////////////////
// WEBPACK FOOTER
// ./src/background/background.module.css
// module id = 262
// module chunks = 11588923914802